const SRT_LANGUAGES = {
  de: "German",
  en: "English",
  es: "Spanish",
  "es-xl": "Spanish - Latin America",
  fr: "French",
  it: "Italian",
  ja: "Japanese",
  ko: "Korean",
  pl: "Polish",
  "pt-br": "Portuguese - Brazil",
  vi: "Vietnamese",
  "zh-cn": "Chinese - Simplified",
  "zh-tw": "Chinese - Traditional",
}

export { SRT_LANGUAGES }
